<template>
    <div class="ts_order receivable-receipt">
        <ts-search :moreSearchItems="moreSearchItems"
                   :boxSearchItems="boxSearchItems"
                   @moreSearchChange="moreSearchChange"
                   @reSearch="reSearch">
            <template slot="button">
                <div class="ts_control-button">
                    <el-button type="primary" @click="batchExportDialogOpen" v-url-check="'finance.reconciliation-checklist.export'">批量导出</el-button>
                </div>
            </template>
            <template slot="tabs">
                <el-tabs v-model="activeName" @tab-click="tableFlagAdd">
                    <el-tab-pane :key="item.NAME"
                                :name="String(item.CODE)"
                                v-for="item in tabValueList">
                        <span slot="label">{{item.NAME}}</span>
                    </el-tab-pane>
                </el-tabs>
            </template>
        </ts-search>
        <div :class="tsTableDivClass">
            <ts-table :ts-table="tsTable" :isPage="tsTable.isPage" @loadingChange="loadingChange" @updateTable="updateTable" class="ts_table">
                <template slot="table" slot-scope="data">
                    <el-table :data="data.table" tooltip-effect="dark"
                              v-loading="loading"
                              @selection-change="handleSelectionChange"
                              row-key="id"
                              ref="multipleTable"
                              :class="tsTableClass">
                        <el-table-column type="selection" reserve-selection width="55"/>
                        <el-table-column v-for="item in tableCurrentItems"
                                        :key="item.prop"
                                        :label="item.label"
                                        :prop="item.prop">
                            <template slot-scope="scope">
                                <template v-if="item.prop === 'custName' && activeName === '99'">
                                    <span>{{ getUnbilledCustName(scope.row) }}</span>
                                </template>
                                <template v-else-if="item.prop === 'actualQuantity' && activeName === '99'">
                                    <span>{{ scope.row.actualQuantity }}{{ scope.row.unit }}</span>
                                </template>
                                <template v-else-if="item.prop === 'goodsNo' && activeName === '99'">
                                    <span>{{ scope.row.goodsNoString }}</span>
                                </template>
                                <template v-else>
                                    <span>{{ scope.row[item.prop] }}</span>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="150px">
                            <template slot-scope="scope">
                                <div class="table-operator">
                                    <i class="el-icon-third-chakan" title="查看" @click="details(scope.row)" v-url-check="'finance.reconciliation-checklist.check'"/>
                                    <!-- <i class="el-icon-third-lajitong" title="删除" @click="remove(scope.row)" v-url-check="'finance.reconciliation-checklist.delete'"/> -->
                                    <i class="el-icon-third-share"  title="导出" @click="exportDialogOpen(scope.row)" v-url-check="'finance.reconciliation-checklist.export'"/>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </ts-table>
        </div>
        <el-dialog
            title="请选择导出模板"
            :before-close="exportDialogClose"
            :visible.sync="exportDialogVisible"
            width="25%"
            center>
            <el-form ref="form" :model="exportForm" label-width="100px">
                <el-form-item label="导出模板：" required>
                    <el-select v-model="exportForm.templateId" placeholder="请选择模板">
                        <el-option
                            v-for="item in exporTemplatetOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportDialogClose">取 消</el-button>
                <el-button type="primary" :loading="exportLoading" @click="exportOrder">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ReconciliationChecklist from '../../bean/order/ReconciliationChecklist';
    import TsTable from '../../mixins/order/common/TsTable';

    export default {
        name: 'ReconciliationChecklist',
        mixins: [TsTable],
        ts: {
            pageType: 'table',
            order: {
                ...ReconciliationChecklist
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.$store.state.tab.update === true) {
                    vm.tsTable.updateFlag += 1;
                    vm.$store.commit('tab/afterUpdate');
                }
            });
        },
        mounted() {
            this.getExportOptions();
            this.getBatchExportOptions();
            this.getUnbilledExportOptions();
            this.tableCurrentItems = JSON.parse(JSON.stringify(this.tableItems));
        },
        data() {
            return {
                tsTable: {
                    url: '/sales/reconciliation_order/list',
                    isTabs: true,
                    table: [],
                    updateFlag: 0,
                    searchObj: {
                        status: '1'
                    }
                },
                unbilledTableItems: [{
                    label: '出库单编号',
                    prop: 'id',
                    overflow: false
                }, {
                    label: '客户名称',
                    prop: 'custName',
                    overflow: false
                }, {
                    label: '出库类型',
                    prop: 'billType',
                    overflow: false
                }, {
                    label: '出库时间',
                    prop: 'operateTime',
                    overflow: false
                }, {
                    label: '出库物品',
                    prop: 'goodsNo',
                    overflow: false
                }, {
                    label: '出库数量',
                    prop: 'actualQuantity',
                    overflow: false
                }, {
                    label: '客户负责人',
                    prop: 'custUserName',
                    overflow: false
                }],
                multipleSelection: [],
                tableCurrentItems: [],
                newDialogVisible: false,
                exportDialogVisible: false,
                form: {
                    custName: '',
                    custId: '',
                    accountName: '',
                    currencyUnit: ''
                },
                accountList: [],
                currencyUnitList: [
                    { label: '人民币', value: '人民币' },
                    { label: '美元', value: '美元' },
                    { label: '欧元', value: '欧元' },
                    { label: '港币', value: '港币' },
                    { label: '日元', value: '日元' },
                    { label: '英镑', value: '英镑' },
                    { label: '法郎', value: '法郎' }
                ],
                exportForm: {
                    isBatch: false,
                    templateId: '',
                    custName: '',
                    id: '',
                    ids: []
                },
                exportLoading: false,
                exportOptions: [],
                batchExportOptions: [],
                unbilledExportOptions: [],
                activeName: '1',
                tabValueList: [
                    { NAME: '未结清', CODE: '1' },
                    { NAME: '未出账', CODE: '99' },
                    { NAME: '已结清', CODE: '2' }
                ]
            }
        },
        computed: {
            exporTemplatetOptions() {
                if (['1', '2'].includes(this.activeName)) {
                    return [...this.exportOptions];
                }
                if (['99'].includes(this.activeName)) {
                    return [...this.unbilledExportOptions];
                }
                return [];
            }
        },
        watch: {
            activeName: {
                handler(val, oldVal) {
                    if (val !== oldVal) {
                        this.$refs.multipleTable.clearSelection();
                    }
                    if (val === '99') {
                        this.tsTable.url = '/sales/reconciliation_order/list/unbilled';
                        delete this.tsTable.searchObj.status;
                        this.tableCurrentItems = [...this.unbilledTableItems];
                        return;
                    }
                    this.tsTable.url = '/sales/reconciliation_order/list';
                    this.tsTable.searchObj.status = this.activeName;
                    if (val === '2') {
                        this.tableCurrentItems = JSON.parse(JSON.stringify(this.tableItems.filter(item => item.prop !== 'overdueAmount')));
                    } else {
                        this.tableCurrentItems = JSON.parse(JSON.stringify(this.tableItems));
                    }
                },
            }
        },
        methods: {
            getUnbilledCustName(row) {
                if (!row.receiptInfo) {
                    return '';
                }
                return row.receiptInfo.receiptUnit;
            },
            setCust(cust) {
                this.accountList = cust.accountList;
                this.form.custName = cust.custName;
                this.form.custId = cust.id;
                if (this.accountList && this.accountList.length === 1) {
                    this.form.accountName = this.accountList[0].accountName;
                } else {
                    this.form.accountName = '';
                }
            },
            clearCust() {
                this.accountList = [];
                this.form.custName = '';
                this.form.custId = '';
                this.form.accountName = '';
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            details(row) {
                if (['1', '2'].includes(this.activeName)) {
                    this.$router.push({
                        path: `/detail-reconciliation-checklist/${row.id}`
                    });
                }
                if (['99'].includes(this.activeName)) {
                    localStorage.setItem('unbilledReconciliationChecklist', JSON.stringify(row));
                    this.$router.push({
                        path: `/detail-unbilled-reconciliation-checklist/${row.id}`
                    });
                }
            },
            async getExportOptions() {
                const { data } = await this.qGet('/global/print/template?orderType=reconciliation&pageSize=999');
                if (data && data.datas) {
                    this.exportOptions = data.datas.filter(item => item.templateName.includes('Chinese')).map(item => {
                        return {
                            label: item.templateName,
                            value: item.id
                        }
                    });
                }
            },
            async getBatchExportOptions() {
                const { data } = await this.qGet('/global/print/template?orderType=BatchReconciliation&pageSize=999');
                if (data && data.datas) {
                    this.batchExportOptions = data.datas.map(item => {
                        return {
                            label: item.templateName,
                            value: item.id
                        }
                    });
                }
            },
            async getUnbilledExportOptions() {
                const { data } = await this.qGet('/global/print/template?orderType=reconciliation_unbilled&pageSize=999');
                if (data && data.datas) {
                    this.unbilledExportOptions = data.datas.map(item => {
                        return {
                            label: item.templateName,
                            value: item.id
                        }
                    });
                }
            },
            batchExportDialogOpen() {
                if (this.multipleSelection.length === 0) {
                    this.$message.error('请选择要导出的对账账单');
                    return;
                }
                if (['1', '2'].includes(this.activeName) && !this.multipleSelection.every(item => item.custName === this.multipleSelection[0].custName && item.custId === this.multipleSelection[0].custId)) {
                    this.$message.error('请选择相同的客户！');
                    return;
                }
                if (['99'].includes(this.activeName) && !this.multipleSelection.every(item => item.receiptInfo && this.multipleSelection[0].receiptInfo && item.receiptInfo.receiptUnit === this.multipleSelection[0].receiptInfo.receiptUnit && item.receiptInfo.receiptUnitId === this.multipleSelection[0].receiptInfo.receiptUnitId)) {
                    this.$message.error('请选择相同的客户！');
                    return;
                }
                this.exportForm.isBatch = true;
                this.exportDialogVisible = true;
                this.exportForm.ids = this.multipleSelection.map(item => item.id);
                if (this.exporTemplatetOptions.length === 1) {
                    this.exportForm.templateId = this.exporTemplatetOptions[0].value;
                }
                if (['1', '2'].includes(this.activeName)) {
                    this.exportForm.custName = this.multipleSelection[0].custName;
                }
                if (['99'].includes(this.activeName)) {
                    this.exportForm.custName = this.multipleSelection[0].receiptInfo.receiptUnit;
                }
            },
            exportDialogOpen(row) {
                this.exportForm.isBatch = false;
                this.exportDialogVisible = true;
                this.exportForm.id = row.id;
                if (this.exporTemplatetOptions.length === 1) {
                    this.exportForm.templateId = this.exporTemplatetOptions[0].value;
                }
                if (['1', '2'].includes(this.activeName)) {
                    this.exportForm.custName = row.custName;
                }
                if (['99'].includes(this.activeName)) {
                    this.exportForm.custName = row.receiptInfo.receiptUnit;
                }
            },
            exportDialogClose() {
                this.exportLoading = false;
                this.exportDialogVisible = false;
                this.exportForm.isBatch = false;
                this.exportForm.templateId = '';
                this.exportForm.custName = '';
                this.exportForm.id = '';
                this.exportForm.ids = [];
            },
            getBatchObj() {
                const template = this.exportOptions.find(item => item.value === this.exportForm.templateId);
                let batchTemplateId = '';
                let type = true;
                if (template && template.label && template.label.includes('Chinese')) {
                    batchTemplateId = this.batchExportOptions.find(item => item.label.includes('Chinese')).value;
                    type = true;
                }
                if (template && template.label && template.label.includes('English')) {
                    batchTemplateId = this.batchExportOptions.find(item => item.label.includes('English')).value;
                    type = false;
                }
                return { batchTemplateId, type };
            },
            async batchExport() {
                const loadingMsg = this.$message.success({
                    message: '正在批量导出...',
                    duration: 0,
                });
                this.exportLoading = true;
                const custName = this.exportForm.custName;
                const Authorization = localStorage.getItem('token');
                if (['1', '2'].includes(this.activeName)) {
                    let { batchTemplateId, type} = this.getBatchObj();
                    const res = await this.qxAxios({
                        url: `/sales/reconciliation_order/BatchExport/${this.exportForm.ids}/${batchTemplateId}/${this.exportForm.templateId}/${type}`,
                        method: 'get',
                        responseType: 'blob',
                        headers: { Authorization }
                    });
                    if (res.status === 200) {
                        loadingMsg.close();
                        this.exportLoading = false;
                        const a = document.createElement('a');
                        a.download = `对账清单-${custName}.xlsx`;
                        a.href = URL.createObjectURL(res.data);
                        a.click();
                        this.exportDialogClose();
                    }
                }
                if (['99'].includes(this.activeName)) {
                    const res = await this.qxAxios({
                        url: `/sales/reconciliation_order/exportReconciliationOrderUnbilled/${this.exportForm.ids}/${this.exportForm.templateId}`,
                        method: 'get',
                        responseType: 'blob',
                        headers: { Authorization }
                    });
                    if (res.status === 200) {
                        loadingMsg.close();
                        this.exportLoading = false;
                        const a = document.createElement('a');
                        a.download = `对账清单-${custName}.xlsx`;
                        a.href = URL.createObjectURL(res.data);
                        a.click();
                        this.exportDialogClose();
                    }
                }
            },
            async singleExport() {
                const custName = this.exportForm.custName;
                const Authorization = localStorage.getItem('token');
                if (['1', '2'].includes(this.activeName)) {
                    const res = await this.qxAxios({
                        url: `/sales/reconciliation_order/export/${this.exportForm.id}/${this.exportForm.templateId}`,
                        method: 'get',
                        responseType: 'blob',
                        headers: { Authorization }
                    });
                    if (res.status === 200) {
                        const a = document.createElement('a');
                        a.download = `对账清单-${custName}.xlsx`;
                        a.href = URL.createObjectURL(res.data);
                        a.click();
                        this.exportDialogClose();
                    }
                }
                if (['99'].includes(this.activeName)) {
                    const res = await this.qxAxios({
                        url: `/sales/reconciliation_order/exportReconciliationOrderUnbilled/${this.exportForm.id}/${this.exportForm.templateId}`,
                        method: 'get',
                        responseType: 'blob',
                        headers: { Authorization }
                    });
                    if (res.status === 200) {
                        const a = document.createElement('a');
                        a.download = `对账清单-${custName}.xlsx`;
                        a.href = URL.createObjectURL(res.data);
                        a.click();
                        this.exportDialogClose();
                    }
                }
            },
            async exportOrder() {
                if (this.exportForm.templateId === '') {
                    this.$message.error('请选择模板');
                    return;
                }
                if (this.exportForm.isBatch) {
                    this.batchExport();
                } else {
                    this.singleExport();
                }
            },
        }
    }
</script>

<style lang="scss">
    .dialog-footer {
        text-align: center;
        .el-button {
            width: 100px;
            height: 36px;
        }
    }
</style>
